import { c as _c } from "react/compiler-runtime";
import { useState, useRef, CSSProperties } from 'react';
export const useFullView = () => {
  const $ = _c(5);
  const [full, setFull] = useState(false);
  let t0;
  if ($[0] !== full) {
    t0 = full ? {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "var(--mantine-color-body)",
      zIndex: 10,
      padding: "1em"
    } : {};
    $[0] = full;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const style = t0;
  let t1;
  if ($[2] !== full || $[3] !== style) {
    t1 = {
      style,
      full,
      setFull
    };
    $[2] = full;
    $[3] = style;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};